// extracted by mini-css-extract-plugin
module.exports = {"ringAccessory":"AvatarOnRubberRing_ringAccessory__C7hws"};